module.exports = __webpack_public_path__ + "img/slide-ai-entry.d0d2cef2.png";